export default "__VITE_ASSET__CRHfzaSS__"